<template>
  <div>
    <h2 class="page-title-bar mb-7">
      <i class="ico ico-system"></i>{{ $t("Label Operations") }}
    </h2>
    <v-tabs v-model="activeTab" background-color="#001e38" color="#fff" grow class="custom-tabs"
      @change="handleTabChange">
      <v-tab>
        {{ $t('LABEL OPERATION') }}
      </v-tab>
      <v-tab>
        {{ $t('LABEL SEARCH') }}
      </v-tab>
    </v-tabs>

    <div v-if="activeTab === 0" class="mt-8">
      <v-row class="searchArea">
        <v-col cols="2">
          <v-select v-model="requestType" class="form-select" :label="`${$t('Request Type')} *`" outlined dense
            hide-details item-text="text" item-value="value" :items="requestTypeOptions"></v-select>
        </v-col>

        <v-col cols="2" class="d-flex align-center pr-0">
          <v-menu v-model="showStartDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="filter.startDate" @click:clear="clearDate(filter, 'startDate')"
                :label="`${$t('Start Time')}`" :placeholder="`${$t('Select Start Date')}`" class="form-input"
                v-bind="attrs" v-on="on" outlined dense hide-details readonly clearable>
                <template v-slot:append>
                  <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="filter.startDate" @change="checkStartDate"
              :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]"
              @input="showStartDatePicker = false" no-title></v-date-picker>
          </v-menu>
          <span class="ml-4 mt-5">~</span>
        </v-col>
        <v-col cols="2">
          <v-menu v-model="showEndDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y
            min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="filter.endDate" @click:clear="clearDate(filter, 'endDate')" v-bind="attrs" v-on="on"
                :label="`${$t('End Time')}`" :placeholder="`${$t('Select End Date')}`" class="form-input" outlined dense
                hide-details readonly clearable>
                <template v-slot:append>
                  <img width="16" height="16" src="@/assets/img/ico-calendar.png" />
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="filter.endDate"
              :locale="languageCodes[$store.getters['dataStore/GET_CURRENT_LANGUAGE']]" @change="checkEndDate"
              @input="showEndDatePicker = false" no-title></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="6" class="d-flex align-end">
          <v-btn class="btn type-search mr-3 mb-1" @click="search()">
            {{ $t("Search") }}
          </v-btn>
          <v-btn class="btn type-search mb-1" @click="clear()">
            {{ $t("Clear") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table item-key="id" class="tbl-type01 mt-10" :headers="headers" :items="tableItems" hide-default-footer>
      </v-data-table>

      <div class="d-flex justify-space-between align-center mt-6">
        <v-dialog v-model="fileUploadVisible" width="650" persistent scrollable>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" :disabled="btnDisabled" v-on="on" class="btn ml-2">{{ $t("File Upload")
            }}</v-btn>
          </template>
          <v-card class="popup add_store_popup">
            <v-card-title>
              <h3 class="page-title-bar">
                <i class="ico ico-product"></i>{{ $t("File Upload") }}
              </h3>
            </v-card-title>
            <v-card-text>
              <div>
                <p class="label-txt mb-3">
                  Request Type <span class="redbold">*</span>
                </p>

                <div class="radio-group">
                  <label class="radio-button" :class="{ active: requestTypePopup === 'ASSIGN' }">
                    <input type="radio" value="ASSIGN" v-model="requestTypePopup" />

                    <div class="icon-img">
                      <img src="@/assets/icons/Assign.svg" alt="" />
                    </div>

                    <div class="text-img">
                      {{ $t('Assign') }}
                    </div>
                  </label>

                  <label class="radio-button" :class="{ active: requestTypePopup === 'UNASSIGN' }">
                    <input type="radio" value="UNASSIGN" v-model="requestTypePopup" />

                    <div class="icon-img">
                      <img src="@/assets/icons/Unassign.svg" alt="" />
                    </div>

                    <div class="text-img">
                      {{ $t('Unassign') }}
                    </div>
                  </label>

                  <label class="radio-button" :class="{ active: requestTypePopup === 'MAPPING' }">
                    <input type="radio" value="MAPPING" v-model="requestTypePopup" />

                    <div class="icon-img">
                      <img src="@/assets/icons/Mapping.svg" alt="" />
                    </div>

                    <div class="text-img">
                      {{ $t('Mapping') }}
                    </div>
                  </label>

                  <label class="radio-button" :class="{ active: requestTypePopup === 'ADD_INFO' }">
                    <input type="radio" value="ADD_INFO" v-model="requestTypePopup" />

                    <div class="icon-img">
                      <img src="@/assets/icons/ad_info.svg" alt="" />
                    </div>

                    <div class="text-img">
                      {{ $t('Add_Info') }}
                    </div>
                  </label>

                  <label class="radio-button" :class="{ active: requestTypePopup === 'DELETE' }">
                    <input type="radio" value="DELETE" v-model="requestTypePopup" />

                    <div class="icon-img">
                      <img src="@/assets/icons/Delete.svg" alt="" />
                    </div>

                    <div class="text-img">
                      {{ $t('Delete') }}
                    </div>
                  </label>
                </div>
              </div>

              <div class="mt-8">
                <p class="label-txt mb-2">
                  {{ $t('Browse File (Extension:') }} {{ requestTypePopup === 'ASSIGN' ? '.link' : requestTypePopup === 'UNASSIGN' ?
                    '.unlink' : requestTypePopup === 'MAPPING' ? '.map' : requestTypePopup === 'ADD_INFO' ? '.elink' :
                      '.del' }})
                  <v-tooltip right content-class="tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="view-format">
                        {{ $t('View File Format') }}
                        <span class="redbold">*</span>
                      </span>
                    </template>
                    <img v-if="requestTypePopup === 'ASSIGN'" src="@/assets/img/assign.png" height="200" width="500" />
                    <img v-if="requestTypePopup === 'UNASSIGN'" src="@/assets/img/Unassign.png" height="200" width="500" />
                    <img v-if="requestTypePopup === 'MAPPING'" src="@/assets/img/mapping.png" height="200" width="500" />
                    <img v-if="requestTypePopup === 'ADD_INFO'" src="@/assets/img/add_info.png" height="200" width="500" />
                    <img v-if="requestTypePopup === 'DELETE'" src="@/assets/img/delete.png" height="200" width="500" />
                  </v-tooltip>
                </p>

                <v-file-input v-model="selectedFile" outlined dense hide-details :placeholder="$t('Select File')"
                  prepend-icon="" append-icon="mdi-file-upload" :accept="acceptedFileExtension" class="form-file"></v-file-input>
              </div>

              <div class="mt-4">
                <p class="label-txt">
                  {{ $t("Selected Files") }}
                </p>

                <div class="selected-file-box mt-2">
                  <div v-if="selectedFile">
                    {{ selectedFile.name }}
                  </div>
                  <div v-else>
                    <p style="font-size: var(--font14);">{{ $t("No files selected") }}</p>
                  </div>
                </div>
              </div>

            </v-card-text>
            <v-card-actions class="d-flex justify-center">
              <v-btn text icon class="btn" @click="uploadFile">{{
                $t("Upload")
              }}</v-btn>
              <v-btn text icon @click="cancelFileUpload" class="btn">{{
                $t("Cancel")
              }}</v-btn>
            </v-card-actions>
         </v-card>
        </v-dialog>
        <div>
          <Pagination @paging="paging($event)" :pageInfoText="pageInfoText" :pageIndex="pageIndex"
            :rowPerPage="rowPerPage" :goToPageInput="goToPageInput" :totalPages="totalPages"
            @updatePage="updatePage($event)" />
        </div>
      </div>
    </div>
    <div v-if="activeTab === 1" class="mt-8">
      <div>
        <v-row class="align-center" style="margin-top: 10px;">
          <v-col cols="3" class="d-flex align-center">
            <v-text-field :label="`${$t('Label Code')}*`" :placeholder="`${$t('Input The Label Code')}`"
              class="form-input mandatory upper-case" outlined dense hide-details v-model="labelCode"
              clearable></v-text-field>
          </v-col>
          <v-col cols="6" class="d-flex align-center mt-6">
            <v-btn text style="width: 170px !important;" class="btn type-search mr-3" @click="getLabelsTypeInfo"
              :disabled="!labelCode || btnDisabled">
              {{ $t("Search") }}
            </v-btn>
            <v-btn text style="width: 170px !important;" class="btn type-search" @click="clearSearch">
              {{ $t("Clear") }}
            </v-btn>
          </v-col>
        </v-row>

      </div>
      <v-dialog v-model="labelDetailsPopup" @click:outside="labelDetailsPopup = false" width="700" persistent>
        <v-card class="popup add_store_popup">
          <v-btn icon dark x-small class="cornerClose" @click="labelDetailsPopup = false">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <div class="popup-titbox align-items-center">
            <h3 class="page-title-bar">
              <i class="ico ico-template"></i>
              {{ $t("Label Properties") }}
            </h3>
            <div class="spacer"></div>
          </div>
          <div class="v-data-table tbl-type01 mt-6 theme--light">
            <div class="v-data-table__wrapper">
              <table class="table">
                <tr v-for="(value, name) of labelDetails" :key="name">
                  <td width="30%">
                    <strong>
                      {{
                        name
                        | camelCaseToProperCase
                        | removeSpacefromCapitalLetter
                      }}
                    </strong>
                  </td>

                  <td>{{ value }}</td>
                </tr>
              </table>
            </div>
          </div>
          <v-card-actions class="d-flex justify-center">
            <v-btn text icon @click="labelDetailsPopup = false" class="btn">{{ $t('Close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import codes from '@/plugins/codes'
import EventBus from '@/plugins/eventBus'
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
import Pagination from '@/components/pagination/Pagination.vue'
import commons from '@/plugins/commons'

const requests = {
  getlabeltype: {
    method: 'get',
    url: '/api/common/labels/type/one'
  }
}
export default {

  components: {
    Pagination
  },
  data () {
    return {
      activeTab: 0,
      requestType: 'ASSIGN',
      requestTypeOptions: [
        { text: this.$t('ASSIGN'), value: 'ASSIGN' },
        { text: this.$t('UNASSIGN'), value: 'UNASSIGN' },
        { text: this.$t('MAPPING'), value: 'MAPPING' },
        { text: this.$t('DELETE'), value: 'DELETE' },
        { text: this.$t('ADDITIONAL INFO'), value: 'ADD_INFO' }
      ],
      tableItems: [],
      showStartDatePicker: false,
      showEndDatePicker: false,
      languageCodes: {
        English: 'en',
        한국어: 'ko',
        Deutsch: 'de',
        Francais: 'fr',
        中文: 'zh',
        Espanol: 'es',
        Italiano: 'it',
        Portugal: 'por',
        日本語: 'jp'
      },
      filter: {
        startDate: null,
        endDate: null
      },
      page: 1,
      totalPages: 1,
      pageIndex: 1,
      rowPerPage: '10',
      rowPerPageList: [5, 10, 20, 50, 100],
      pageInfoText: '',
      totalVisiblePages: 5,
      goToPageInput: 1,
      fileUploadVisible: false,
      requestTypePopup: 'ASSIGN',
      selectedFile: null,
      labelDetails: {
        labelCode: '',
        name: '',
        displayWidth: 0,
        displayHeight: 0,
        totalPage: 0,
        colorType: '',
        resolution: 0,
        nfc: false
      },
      labelDetailsPopup: false,
      labelCode: '',
      btnDisabled: null
    }
  },
  filters: {
    // Filter definitions
    camelCaseToProperCase (value) {
      return value.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
        return str.toUpperCase()
      })
    },
    removeSpacefromCapitalLetter (value) {
      return value.replace(/([A-Z])\s(?=[A-Z])/g, '$1')
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('#'), value: 'id', sortable: false, align: 'center', width: '7%' },
        { text: this.$t('FILE NAME'), value: 'fileName' },
        { text: this.$t('RESULT'), value: 'status' },
        { text: this.$t('TOTAL'), value: 'total' },
        { text: this.$t('SUCCESS'), value: 'valid' },
        { text: this.$t('FAIL'), value: 'invalid' },
        { text: this.$t('START TIME'), value: 'insertTime' },
        { text: this.$t('COMPLETE TIME'), value: 'updateTime' }
      ]
    },
    acceptedFileExtension () {
      const map = {
        ASSIGN: '.link',
        UNASSIGN: '.unlink',
        MAPPING: '.map',
        ADD_INFO: '.elink',
        DELETE: '.del'
      }
      return map[this.requestTypePopup]
    },
    selectedStore () {
      return this.$store.getters['dataStore/GET_SELECTED_STORE'].code
    },
    ...mapGetters({
      store: 'dataStore/GET_SELECTED_STORE'
    })
  },
  mounted () {
    EventBus.$emit('enableSelectedStores', true)
    this.$store.dispatch('auth/getDisabledBtn', '2601').then(flag => {
      this.btnDisabled = flag
    })
    this.fetchFileHistory()
  },
  methods: {
    clearDate (searchBy, dateType) {
      searchBy[dateType] = null
    },
    search () {
      this.page = 1
      this.pageIndex = 1
      this.goToPageInput = 1
      this.rowPerPage = '10'
      this.fetchFileHistory()
    },
    clear () {
      this.filter.startDate = null
      this.filter.endDate = null
      this.fetchFileHistory()
    },
    checkStartDate (val) {
      if (val > this.filter.endDate) {
        this.filter.startDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The start date is must be prior to the end date.')
        )
      }
    },
    checkEndDate (val) {
      if (val < this.filter.startDate) {
        this.filter.endDate = null
        EventBus.$emit(
          'messageAlert',
          this.$t('The end date is must be after the start date.')
        )
      }
    },
    resetOperationTab () {
      this.requestType = 'ASSIGN'
      this.filter = {
        startDate: null,
        endDate: null
      }
      this.tableItems = []
      this.cancelFileUpload()
    },
    resetSearchTab () {
      this.labelCode = ''
    },
    fetchFileHistory: debounce(function () {
      const params = {
        store: this.requestType !== 'UNASSIGN' ? this.selectedStore || null : null,
        requestType: this.requestType,
        startTime: this.filter.startDate ? `${this.filter.startDate} 00:00:00` : null,
        endTime: this.filter.endDate ? `${this.filter.endDate} 00:00:00` : null,
        page: this.page - 1,
        size: Number(this.rowPerPage)
      }
      this.$utils
        .callAxios(
          codes.requests.getLinkOperationHistory.method,
          codes.requests.getLinkOperationHistory.url,
          { params: params }
        )
        .then((res) => {
          this.tableItems = []
          if (res.status === 200 && res.data) {
            this.tableItems = res.data.labelOperationFileLogsList.map((item, index) => {
              return {
                id: ((this.page - 1) * this.rowPerPage) + index + 1,
                ...item,
                insertTime: commons.convertDate(item.insertTime),
                updateTime: commons.convertDate(item.updateTime)
              }
            })
          }
          console.log(res.headers)
          this.pageInfoText = commons.getPageInfoText(res.headers)
          this.totalPages = Number(res.headers['x-totalpages'])
          this.pageIndex = Number(res.headers['x-number']) + 1
        })
        .catch((error) => {
          this.tableItems = []
          const headers = {}
          headers['x-totalelements'] = 0
          this.pageInfoText = commons.getPageInfoText(headers)
          this.totalPages = 0
          this.pageIndex = 0
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage)
          )
        })
    }, 100),
    async uploadFile () {
      if (this.selectedFile === null || this.selectedFile === undefined) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Select file to upload.')
        )
        return
      }
      // Validate file format
      const allowedExtensions = {
        ASSIGN: '.link',
        UNASSIGN: '.unlink',
        MAPPING: '.map',
        ADD_INFO: '.elink',
        DELETE: '.del'
      }
      const expectedExt = allowedExtensions[this.requestTypePopup]
      const fileName = this.selectedFile.name
      const fileExt = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      if (fileExt !== expectedExt) {
        EventBus.$emit('messageAlert', {
          title: this.$t('Invalid File Format'),
          message: this.$t(`Expected "${expectedExt}" file for ${this.requestTypePopup} type.`)
        })
        return
      }
      const labelFileTypeMap = {
        ASSIGN: 'LINK',
        UNASSIGN: 'UNLINK',
        MAPPING: 'MAPPING',
        ADD_INFO: 'ADD_INFO',
        DELETE: 'DELETE'
      }
      const fileSize = (
        this.selectedFile.size / (1024 * 1024)
      ).toFixed(2)
      if (fileSize > 14) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Files larger than 14MB cannot be uploaded.')
        )
        return
      }
      const formData = new FormData()
      formData.append('file', this.selectedFile)
      formData.append('uploadType', 'LABEL')
      formData.append(
        'labelFileType',
        labelFileTypeMap[this.requestTypePopup]
      )
      const params = {
        store: this.selectedStore || null
      }
      const config = {
        params: params,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$utils
        .callAxiosWithBody(
          codes.requests.postLinkFileUpload.method,
          codes.requests.postLinkFileUpload.url,
          formData,
          config
        )
        .then((res) => {
          EventBus.$emit(
            'messageAlert',
            this.$t(res.data.responseMessage)
          )
          this.cancelFileUpload()
          this.fetchFileHistory()
        })
        .catch((error) => {
          switch (error.response?.status) {
            default:
              EventBus.$emit(
                'messageAlert',
                this.$t('File upload failed.')
              )
              break
          }
          this.cancelFileUpload()
        })
    },
    async handleTabChange (tab) {
      if (tab === 0) {
        this.resetOperationTab()
        await this.fetchFileHistory()
      } else {
        this.resetSearchTab()
      }
    },
    cancelFileUpload () {
      this.selectedFile = null
      this.requestTypePopup = 'ASSIGN'
      this.fileUploadVisible = false
    },
    paging (page = this.page) {
      this.page = page
      this.goToPageInput = page
      this.fetchFileHistory()
    },
    updatePage (event) {
      this.rowPerPage = event.toString()
      this.paging(1)
    },
    clearSearch () {
      this.labelCode = ''
    },
    getLabelsTypeInfo () {
      const config = { params: { labelCode: this.labelCode } }
      this.$utils
        .callAxios(
          requests.getlabeltype.method,
          requests.getlabeltype.url,
          config
        )
        .then(res => {
          if (res.status === 200 && res.data) {
            console.log(res)
            this.labelDetailsPopup = true
            const labelData = res.data
            this.labelDetails.labelCode = labelData.labelCode
            this.labelDetails.name = labelData.name
            this.labelDetails.displayWidth = labelData.displayWidth
            this.labelDetails.displayHeight = labelData.displayHeight
            this.labelDetails.totalPage = labelData.totalPage
            this.labelDetails.colorType = labelData.colorType
            this.labelDetails.resolution = labelData.resolution
            this.labelDetails.nfc = labelData.nfc
          } else {
            EventBus.$emit(
              'messageAlert',
              this.$t('No data available')
            )
          }
        })
        .catch(error => {
          this.labelDetails.labelCode = ''
          this.labelDetails.name = ''
          this.labelDetails.displayWidth = ''
          this.labelDetails.displayHeight = ''
          this.labelDetails.totalPage = ''
          this.labelDetails.colorType = ''
          this.labelDetails.resolution = ''
          this.labelDetails.nfc = false
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.responseMessage)
          )
        })
    }
  },
  watch: {
    requestType () {
      this.page = 1
      this.pageIndex = 1
      this.goToPageInput = 1
      this.rowPerPage = '10'
      this.fetchFileHistory()
    },
    store: {
      handler () {
        this.page = 1
        this.pageIndex = 1
        this.goToPageInput = 1
        this.rowPerPage = '10'
        this.fetchFileHistory()
      }
    }
  }
}
</script>
<style scoped>
.table tr td {
  border: 1px solid #ccc;
  padding: 3px;
  border-collapse: collapse;
}

.popup {
  padding: 20px;
}

.tit-section {
  background-image: linear-gradient(#ececec, #ececec);
  color: rgba(0, 0, 0, 0.7);
}

/* ::v-deep.theme--light.v-select .v-select__selection--comma {
  color: #fafafa !important;
} */

.custom-tabs {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}

::v-deep .v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
  background-color: #e7eaec !important;
  color: #999 !important;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio-button {
  width: 100px;
  height: 100px;
  border: 2px solid #d9d9d9;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.radio-button.active {
  border-color: #001e38;
}

.radio-button input {
  display: none;
}

.icon-img img {
  width: 36px;
  height: 36px;
  opacity: 0.2;
}

.radio-button.active .icon-img img {
  opacity: 1;
}

.text-img {
  margin-top: 14px;
  font-size: 16px;
  font-weight: 600;
  color: #d9d9d9;
}

.radio-button.active .text-img {
  color: #001e38;
}

.label-txt {
  font-weight: 600;
}

.redbold {
  color: red;
}

.view-format {
  color: #001e38;
  font-weight: 700;
  cursor: pointer;
}

.form-file.v-text-field--outlined {
  padding-top: 0;
}

.selected-file-box {
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 8px 12px;
}

::v-deep.v-tooltip__content {
  padding: 0px !important;
  margin-left: 0 !important;
  background-color: #001e38 !important;
  opacity: 1 !important;
}

::v-deep.v-tooltip__content::after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  border-left: none;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #001e38;
  left: -10px;
  top: 41%;
}
</style>
